import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { eUnitActionTypeIds, IUnitActionTypes } from "../../action-types/y-te/IUnitActionTypes";
import { IUnitPageStateModel } from "../../page-state-model/y-te/IUnitPageState";

const initialState: IUnitPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	units: [],
	unit_editing: undefined,
	unit_selected_ids: [],
	is_show_detail_modal: false,
	is_show_delete_confirm: false,
	is_loading_detail: false
}

export const unitReducer = (state: IUnitPageStateModel = initialState, action: IUnitActionTypes): IUnitPageStateModel => {
	switch (action.type) {
		case eUnitActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eUnitActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				units: action.payload
			}
		case eUnitActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				units: []
			}
		case eUnitActionTypeIds.LOAD_DETAIL_START:
			return {
				...state,
				is_loading_detail: true
			}
		case eUnitActionTypeIds.LOAD_DETAIL_SUCCESS:
			return {
				...state,
				is_loading_detail: false,
				unit_editing: action.payload
			}
		case eUnitActionTypeIds.LOAD_DETAIL_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				is_loading_detail: false
			}
		case eUnitActionTypeIds.SHOW_DETAIL:
			return {
				...state,
				is_show_detail_modal: true,
				unit_editing: action.payload
			}
		case eUnitActionTypeIds.CLOSE_DETAIL:
			return {
				...state,
				is_show_detail_modal: false,
				unit_editing: undefined
			}
		case eUnitActionTypeIds.CHANGE_SELECTED_IDS:
			return {
				...state,
				unit_selected_ids: action.payload
			}
		case eUnitActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eUnitActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eUnitActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eUnitActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success(action.payload ? "Cập nhật thành công" : "Thêm thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_detail_modal: false,
				unit_editing: undefined
			}
		case eUnitActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eUnitActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eUnitActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false,
				unit_editing: undefined,
				unit_selected_ids: []
			}
		case eUnitActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		default:
			return state;
	}
}
